export { Equation as NEquation, equationProps } from './src/Equation';
